import type {
  MediatorTransitionResult,
  TypedEvent,
} from "@/shared/lib/componentHierarchy";

export type DesktopHeaderEvent = {
  type:
    | "desktop-header.jukebox.show"
    | "desktop-header.jukebox.hide"
    | "desktop-header.jukebox.open"
    | "desktop-header.announcement.open";
};

export type DesktopHeaderEffect = "open-jukebox" | "open-announcement";

export function transitionDesktopHeader(
  isJukeboxOpen: boolean,
  event: TypedEvent,
): MediatorTransitionResult<boolean, DesktopHeaderEffect> {
  switch (event.type) {
    case "desktop-header.jukebox.show":
      return { status: "handled", state: true };
    case "desktop-header.jukebox.hide":
      return { status: "handled", state: false };
    case "desktop-header.jukebox.open":
      return {
        status: "handled",
        state: isJukeboxOpen,
        effects: isJukeboxOpen ? ["open-jukebox"] : [],
      };
    case "desktop-header.announcement.open":
      return {
        status: "handled",
        state: isJukeboxOpen,
        effects: ["open-announcement"],
      };
    default:
      return { status: "unhandled" };
  }
}
